<template>
  <div v-if="project.collaterals" class="block-collaterals">
    <div class="dp-section-title">Залог недвижимости</div>

    <info-card v-for="collateral in project.collaterals" :key="collateral.id" class="mb-3">
      <info-row label="Тип объекта">{{ project.loan.objectType }}</info-row>
      <info-row label="Место расположения объекта">{{ collateral.address }}</info-row>
      <info-row label="Площадь объекта">{{ collateral.square }} м<sup>2</sup></info-row>
      <info-row label="Дата приобретения">
        <date-format :date="collateral.purchaseDate"/>
      </info-row>
      <info-row label="Основание приобретения">{{ collateral.purchaseReason }}</info-row>
      <info-row label="Оценочная стоимость">
        <money :money="collateral.cost"/>
      </info-row>
      <info-row label="LTV при целевой сумме">{{ collateral.ltv }}</info-row>
      <info-row v-if="collateral.comment" label="Комментарий по залогу" stacked>
        <rich-content :html="collateral.comment"/>
      </info-row>
    </info-card>

    <div class="dp-section-title">Поручительство</div>
    <div v-if="project.guarantors.length === 0" class="block-collaterals__empty">
      Нет
    </div>
    <info-card v-else>
      <info-row v-for="guarantor in project.guarantors" :key="guarantor.id" :label="guarantor.fullName">
        Доля в УК: {{ guarantor.share ? (Math.floor(guarantor.share * 10) / 10) + "%" : "-" }}
      </info-row>
    </info-card>
  </div>
</template>

<script>
import Money from "@/components/common/components/Money.vue";
import DateFormat from "@/components/common/components/DateFormat.vue";
import InfoCard from "@/components/common/components/InfoCard.vue";
import InfoRow from "@/components/common/components/InfoRow.vue";
import RichContent from "@/components/common/components/RichContent.vue";

export default {
  name: "DetailedProjectCollaterals",
  components: {DateFormat, Money, InfoCard, InfoRow, RichContent},
  props: {
    project: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.block-collaterals__empty {
  color: var(--secondary-gray);
}
</style>
